import React, { useState,useEffect } from 'react';
import { Container,Row,Col,Placeholder } from 'react-bootstrap';
const AlumniBytes = ({sp}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    const mtArray = {259:21,320:32,368:43,347:48};
    useEffect(()=>
    {
        const MiscellaneousByTypeAll = async (mtId) => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscFileHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousType Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeAll : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeAll : Error', error.message);
            }
        };
        if(sp?.sp_id > 0 )
        {            
            MiscellaneousByTypeAll(mtArray[sp.sp_id]);
        }
        // eslint-disable-next-line
    },[sp])
    return (
        <section className="hp-department" style={{backgroundImage: `url(${global.config.uploadPath+'1872917482.png'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat"}}>
            <Container className="py-md-5 py-4 text-center">
                <h2 className='text-uppercase'>{appLanguage === 'hi' ? "पूर्व छात्रों की ओर से बाइट्स" : "Bytes from Alumni's"}</h2>
                <span className="mb-4 sub-heading"></span>
                {isLoading ? (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 justify-content-center g-3">
                {[...Array(6)].map((_,index)=>(
                    <Col key={index}>
                        <div className="ratio ratio-4x3 border border-4 rounded" data-aos="flip-up" data-aos-duration="1000">
                            <Placeholder className="w-100 h-100" />
                        </div>
                    </Col>
                ))}
                </Row>  
                ) : (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 justify-content-center g-3">
                {Miscellaneous.map((sm,index)=>(
                    <Col key={index}>
                        <div className="ratio ratio-4x3 border border-4 rounded overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                            <video controls>
                                <source src={sm.miscFile} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </Col>
                ))}
                </Row>
                )}
            </Container>
        </section>
    );    
}
export default AlumniBytes;